import { Toaster as Sonner, toast } from 'sonner'
import styles from './sonner.module.css'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = (props: ToasterProps) => {
  const { className, style, ...rest } = props

  return (
    <Sonner
      theme="light"
      closeButton
      duration={5000}
      richColors
      className={[styles.toaster, className].filter(Boolean).join(' ')}
      // Sonner's mobile rule gives the fixed toaster width:100% *and* a 16px
      // left offset, making the document 16px wider than the viewport. Keep
      // the same gutters while making the container itself fit between them.
      style={{ width: 'min(356px, calc(100vw - 32px))', ...style }}
      // On mobile sonner pins toasts to the bottom edge; add the safe-area
      // inset so they clear the home indicator in the edge-to-edge WebView.
      mobileOffset={{ bottom: 'calc(16px + var(--safe-area-inset-bottom))' }}
      {...rest}
    />
  )
}

export { Toaster, toast }
